<template lang="pug">
pr-wrapper.vod-detail(
  v-nv:scope="'vod-detail'",
  data-down="vods",
  @nv-scope-focus.native="focused",
  @nv-scope-blur.native="moved",
  @nv-back.native="goBack"
)
  pr-title.font-weight-bold(size="large") {{ vod.title }}
  pr-subtitle.mb-3 {{ vod.content }}
  .row.no-gutters.align-items-center.mt-2.font-weight-bold
    .col.col-auto(v-show="vod.imdb")
      icon.mr-2.text-warning(:icon="'fas star'")
      | {{ vod.imdb }}
      icon.mx-4.small(:icon="'circle'")
    .col.col-auto {{ vod.category }}
  pr-button.watch.mt-5.mr-5.font-weight-bold.themed(outline, v-nv, @nv-enter="play('continue')", v-show="continue_")
    icon.mr-3(:icon="'fas play'")
    | {{ $t("Continue") }}
  pr-button.watch.mt-5.font-weight-bold.themed(outline, v-nv, @nv-enter="play")
    icon.mr-3(:icon="'fas play'")
    | {{ vod.price && !vod.owned ? $t("Buy") : $t("Watch") }}
    span.ml-1(v-show="vod.price && !vod.owned") - {{ $t("currency", [vod.price]) }}
</template>

<script>
import { mapGetters, mapMutations } from "vuex"
export default {
  name: "vod-detail",
  data() {
    return {
      continue_: false,
      startWith_: false,
      timeout: null,
      interval: null,
      intent: false
    }
  },
  computed: {
    ...mapGetters("vod", ["vod"])
  },
  watch: {
    async vod() {
      this.isInterrupted()
      await this.$nextTick()
      _$.nav.refreshScope("vod-detail")
    }
  },

  mounted() {
    this.isInterrupted()
    _$.nav.sync("vod-detail")
  },
  methods: {
    async focused() {
      if (this.intent || (_$.nav.prevScopeName() !== "vod-categories" && _$.nav.prevScopeName() !== "vods")) return
      if (this.timeout) this.timeout = _$.removeTimeout(this.timeout)

      this.timeout = _$.makeTimeout(async () => {
        this.intent = true
        const res = await __.media.play(this.vod.trailer)
        this.setStatus(res ? "trailer" : false)
        this.intent = false
      }, 1500)
    },
    async play(type_) {
      if (this.vod.price && !this.vod.owned) {
        const res = await __.order.add({
          title: this.vod.title,
          count: 1,
          id: this.vod.id,
          price: this.vod.price,
          main: this.vod.id, //this.vod.category,
          endpoint: __.device.config("PAYTV_ENDPOINT"),
          action_type: "vod"
        })
        if (!res) return

        await this.$store.dispatch("services/fetchOrders")
        await this.$nextTick()
        if (!this.vod.owned) return
      }

      if (this.vod.pin) {
        const res = await __.media.pinCodeMiddleware(this.vod)
        if (!res) return false
      }

      if (this.intent) return
      if (this.timeout) this.timeout = _$.removeTimeout(this.timeout)
      if (type_ === "continue") this.startWith_ = _$.store.getItem(`vod.watchlist.${this.vod.id}`)

      this.intent = true
      if (__.media.isActive()) await __.media.stop()
      _$.vue.$on("mediaPlaying", this.played)
      _$.vue.$on(["mediaEnded", "mediaStopped"], this.positionControl)

      await this.$popup.videoWithPlayerControl(this.vod.url, false)

      __.platform.background(this.vod.poster)
      this.setStatus(false)

      _$.vue.$off("mediaPlaying", this.played)
      _$.vue.$off(["mediaEnded", "mediaStopped"], this.positionControl)

      this.intent = false
    },
    async played() {
      this.setStatus("watch")
      this.positionSaver(this.vod)
      if (this.startWith_) {
        const second = this.startWith_
        this.startWith_ = false
        await _$.sleep(1000)
        await __.media.setPosition(second)
      }
    },
    moved() {
      if (this.timeout) _$.removeTimeout(this.timeout)
    },
    goBack() {
      _$.nav.changeScope("vods")
    },
    isInterrupted() {
      this.continue_ = _$.true(_$.store.getItem(`vod.watchlist.${this.vod.id}`))
    },
    async positionControl(event) {
      if (!event || typeof event !== "object") return
      if (event.type === "mediaEnded") this.positionSaver(this.vod, true, true)
      else this.positionSaver(this.vod, true)
    },
    async positionSaver(_vod, kill = false, completed = false) {
      if (this.interval) _$.removeInterval(this.interval)
      if (kill && !completed) return

      const vod = this.$store.getters["vod/vods"].find(vod => vod.id === _vod.id)
      if (!vod) return

      if (kill && completed) {
        return _$.store.deleteItem(`vod.watchlist.${vod.id}`)
      }

      this.interval = _$.makeInterval(async () => {
        const duration = await __.media.getDuration(),
          position = await __.media.getPosition(),
          diff = duration - position

        if (duration > 2400 && diff <= 300) return this.positionSaver(vod, true, true)

        _$.store.setItem(`vod.watchlist.${vod.id}`, position)
      }, 10000)
    },
    ...mapMutations("vod", ["setStatus"])
  }
}
</script>

<style lang="scss" scoped>
.vod-detail {
  overflow: initial;

  .watch {
    transform-origin: left;
  }
}
</style>
